// Website positioning. Marketing focus does not change product eligibility.

export const BRAND = {
  name: "Vowent",
  operator: "Owo360 Ltd",
  tagline: "Dating should lead somewhere.",
  promise: "Meet with intention. Build something meaningful.",
  description: "Vowent is a faith-centred dating app for adults 21+, built with Christian and Muslim singles in mind and focused on meaningful, lasting relationships.",
  philosophy: "Built around intention, faith, values, family and long-term compatibility.",
  minAge: 21,
  regions: ["United Kingdom", "Nigeria"],
  supportEmail: "support@vowent.com",
  privacyEmail: "support@vowent.com",
} as const;

export type Faq = { q: string; a: string };

export const FAQS: Faq[] = [
  {
    q: "Who is Vowent for?",
    a: "Vowent is for adults aged 21 and over seeking meaningful, serious relationships, built with Christian and Muslim singles in mind. This focus is not a requirement to belong to either faith. Vowent currently provides opposite-sex matching between adult men and women.",
  },
  {
    q: "What is a persona?",
    a: "A short, AI-drafted summary of what you're building, what makes you feel secure, your pace, and your dealbreakers. It powers better matches and gives context for real conversations. You review and approve it.",
  },
  {
    q: "How does the AI work?",
    a: "It helps summarise compatibility and suggest respectful prompts. It's guidance, not a guarantee, and it never messages other members on your behalf or misrepresents you.",
  },
  {
    q: "Where is Vowent available?",
    a: "Vowent connects people across the United Kingdom and Nigeria, with honest distance expectations built into matching.",
  },
  {
    q: "How does Vowent keep me safe?",
    a: "Verification, report and block tools, safety plans, and public-first guidance are built in. If there's ever immediate danger, contact your local emergency services first.",
  },
  {
    q: "Is my data sold?",
    a: "No. Vowent does not sell your relationship persona answers. See the Privacy Policy for how your information is used.",
  },
];
